import { render } from "./PointInformationPublicModal.vue?vue&type=template&id=45493b80&scoped=true"
import script from "./PointInformationPublicModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PointInformationPublicModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./PointInformationPublicModal.vue?vue&type=style&index=0&id=45493b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45493b80"]])

export default __exports__